import SupportagentIcon from "./SupportagentIcon"

export default  SupportagentIcon;
